var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { bind } from "decko";
import { sequence } from "@typed/sequence";
import Button from "./button";
export class Fileupload extends React.Component {
    constructor(props) {
        super(props);
    }
    applyChromiumFix() {
        if (this.inputElRef) {
            this.inputElRef.value = "";
        }
    }
    handleChange(event) {
        event.preventDefault();
        event.stopPropagation();
        const fileList = event.currentTarget.files;
        if (this.props.onUpload && fileList) {
            if (this.props.multiple) {
                const files = [];
                for (let index = 0; index < fileList.length; index++) {
                    files.push(fileList[index]);
                }
                sequence(files, this.props.onUpload).catch();
            }
            else {
                this.props.onUpload(fileList[0]).catch();
            }
            this.applyChromiumFix();
        }
    }
    handleClick(event) {
        this.inputElRef && this.inputElRef.click();
        this.props.onClick && this.props.onClick(event);
    }
    render() {
        const _a = this.props, { multiple, children } = _a, buttonProps = __rest(_a, ["multiple", "children"]);
        return (React.createElement(Button, Object.assign({}, buttonProps, { onClick: this.handleClick }),
            children,
            React.createElement("input", { ref: (el) => (this.inputElRef = el), type: "file", style: { display: "none" }, onChange: this.handleChange, multiple: multiple })));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Fileupload.prototype, "applyChromiumFix", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fileupload.prototype, "handleChange", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fileupload.prototype, "handleClick", null);
export default Fileupload;
//# sourceMappingURL=fileupload.js.map